module.exports = __webpack_public_path__ + "static/img/SSSH5.5056ece5.png";